<ion-header>
    <ion-toolbar>
      <ion-title>{{ 'LANGUAGE_SWITCHER.TITLE' | translate }}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  
  <ion-content>
    <div class="language-switcher-container">
      <div class="current-language-section">
        <h2>{{ 'LANGUAGE_SWITCHER.CURRENT_LANGUAGE' | translate }}</h2>
        <div class="current-language-display">
          <span class="flag">{{ getCurrentLanguageFlag() }}</span>
          <span class="language-name">{{ getCurrentLanguageName() }}</span>
        </div>
      </div>
  
      <div class="language-options">
        <h3>{{ 'LANGUAGE_SWITCHER.SELECT_LANGUAGE' | translate }}</h3>
        
        <ion-list>
          <ion-item 
            *ngFor="let language of availableLanguages" 
            (click)="changeLanguage(language.code)"
            [class.selected]="currentLanguage === language.code"
            button>
            <ion-label>
              <div class="language-option">
                <span class="flag">{{ language.flag }}</span>
                <span class="language-name">{{ language.name }}</span>
                <ion-icon 
                  *ngIf="currentLanguage === language.code" 
                  name="checkmark" 
                  color="primary">
                </ion-icon>
              </div>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
  
      <div class="info-section">
        <ion-note>
          {{ 'LANGUAGE_SWITCHER.INFO_MESSAGE' | translate }}
        </ion-note>
      </div>
    </div>
  </ion-content>